var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoReferral = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interlock",
    transform: "translate(-.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29290",
    "data-name": "Group 29290",
    transform: "translate(.002)",
    fill: "#00a1af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48549",
    "data-name": "Path 48549",
    d: "M2.656,9.475,4.93,7.2,3.687,5.958A1.608,1.608,0,0,1,5.96,3.684l5.488,5.488L13.722,6.9,8.234,1.41A4.823,4.823,0,1,0,1.413,8.231Z",
    transform: "translate(-.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48550",
    "data-name": "Path 48550",
    d: "M140.333,194.465l-2.274,2.274,1.243,1.243a1.608,1.608,0,0,1-2.274,2.274l-5.488-5.488-2.274,2.274,5.488,5.488a4.823,4.823,0,0,0,6.821-6.821Z",
    transform: "translate(-120.986 -181.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48551",
    "data-name": "Path 48551",
    d: "M197.983,3.689a1.608,1.608,0,0,1,2.274,2.274l-5.488,5.488,2.274,2.274,5.488-5.488a4.823,4.823,0,0,0-6.821-6.821l-1.243,1.243,2.274,2.274Z",
    transform: "translate(-181.941 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48552",
    "data-name": "Path 48552",
    d: "M5.96,139.3a1.608,1.608,0,0,1-2.274-2.274l5.488-5.488L6.9,129.268l-5.488,5.488a4.823,4.823,0,0,0,6.821,6.821l1.243-1.243L7.2,138.06Z",
    transform: "translate(-.002 -120.987)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoReferral);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_referral.bc058231393169e9f2949eb4b7396f11.svg";